import React from "react";
import { Head } from "../../components";
import { Attendance } from "../../components/Attendance/Attendance";
import "./class_attendance.css";

export const Class_attendance = () => {
  return (
    <>
      <div className="class_attendance-g">
        <Head title="Profesor" />
        <Attendance/>
      </div>
    </>
  );
}

export default Class_attendance;